import { render } from "./Suggestion.vue?vue&type=template&id=b4b0499c"
import script from "./Suggestion.vue?vue&type=script&lang=js"
export * from "./Suggestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__